import { render, staticRenderFns } from "./TagInputs.vue?vue&type=template&id=52a917c2"
import script from "./TagInputs.vue?vue&type=script&lang=js"
export * from "./TagInputs.vue?vue&type=script&lang=js"
import style0 from "./TagInputs.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports